import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { x } from '@xstyled/styled-components';
import { PackageSectionItem, Title, Text, colors, ExpandRightIcon, ProductDescription } from '@aftersale-next/ui';
import { useTrackingMode } from '../../hooks/use-app-mode';
import { usePackageIndex } from '@aftersale-next/atoms';
import { useRouter } from 'next/router';
import { formatToDMY } from '../../utils/format-date';
import { useTranslation } from 'react-i18next';
import { useStatusDelivered } from '../../hooks/use-package-status';
import { statusOf } from '../../utils/status-color-converter';
import { getProductsNames } from '../../utils/get-products-names';
export default function PackagesListItem(_ref) {
  var _pkg$events$, _events$;

  var pkg = _ref["package"];
  var deliveryDate = pkg.deliveryDate,
      estimatedDeliveryDate = pkg.estimatedDeliveryDate,
      events = pkg.events,
      packageIndex = pkg.packageIndex,
      products = pkg.products,
      code = pkg.code;

  var _useTrackingMode = useTrackingMode(),
      _useTrackingMode2 = _slicedToArray(_useTrackingMode, 2),
      setTrackingMode = _useTrackingMode2[1];

  var _usePackageIndex = usePackageIndex(),
      _usePackageIndex2 = _slicedToArray(_usePackageIndex, 2),
      setPackageIndex = _usePackageIndex2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();
  var isDelivered = useStatusDelivered(pkg);
  var statusColor = statusOf((_pkg$events$ = pkg.events[0]) === null || _pkg$events$ === void 0 ? void 0 : _pkg$events$.code);

  var handlePackageClick = function handlePackageClick() {
    setPackageIndex(packageIndex);
    router.push("".concat(router.asPath, "&package_index=").concat(packageIndex), undefined, {
      shallow: true,
      scroll: false
    });
    setTrackingMode('package-details');
  };

  var isPackageDelivery = isDelivered && deliveryDate;
  var hasEvents = !!events.length;
  return /*#__PURE__*/_jsxs(PackageSectionItem, {
    onClick: handlePackageClick,
    children: [/*#__PURE__*/_jsxs(x.div, {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      w: "full",
      children: [/*#__PURE__*/_jsxs(Title, {
        fontSize: "14px",
        transform: "uppercase",
        children: [t('PACKAGE'), " ", packageIndex + 1, (isPackageDelivery || estimatedDeliveryDate) && ' • ']
      }), /*#__PURE__*/_jsxs(Text, {
        letterSpacing: "1px",
        size: "12px",
        color: colors.textForeground,
        children: [isPackageDelivery && "".concat(t('DELIVERED'), "!"), estimatedDeliveryDate && !isPackageDelivery && "".concat(t('UNTIL'), " ").concat(formatToDMY(estimatedDeliveryDate))]
      }), /*#__PURE__*/_jsx(x.div, {
        ml: "auto",
        children: /*#__PURE__*/_jsx(ExpandRightIcon, {})
      })]
    }), !!code && /*#__PURE__*/_jsx(x.div, {
      display: "flex",
      w: "full",
      mt: "16px",
      children: /*#__PURE__*/_jsx(Text, {
        breakWord: true,
        letterSpacing: "1px",
        size: "12px",
        children: t('TRACKING_WITH_CODE').replace(':code', code)
      })
    }), products && /*#__PURE__*/_jsx(x.div, {
      display: "flex",
      w: "full",
      mt: "16px",
      children: /*#__PURE__*/_jsx(ProductDescription, {
        children: /*#__PURE__*/_jsx("p", {
          children: getProductsNames(products)
        })
      })
    }), /*#__PURE__*/_jsx(x.div, {
      w: "full",
      mt: "16px",
      children: /*#__PURE__*/_jsxs(Text, {
        letterSpacing: "1px",
        size: "12px",
        color: statusColor,
        children: [isPackageDelivery && "".concat(t('DELIVERED_DAY'), " ").concat(formatToDMY(deliveryDate)), !isPackageDelivery && hasEvents && ((_events$ = events[0]) === null || _events$ === void 0 ? void 0 : _events$.description)]
      })
    })]
  });
}